<template>
  <div>
    <div class="reservedInstances-title">
      <div>{{ $t("RAM.ALI.ReservedInstances.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:ali:reservedInstances:update'
          ]"
          :loading="modal_loading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:ali:reservedInstances:export'
          ]"
          :loading="modal_loading"
          @click="exportList"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <div class="reservedInstances-top">
      <reserved-instances-search ref="search"></reserved-instances-search>
    </div>
    <table-reserved-instances></table-reserved-instances>
  </div>
</template>

<script>
import ReservedInstancesSearch from "../reservedInstances/ReservedInstancesSearch";
import TableReservedInstances from "../reservedInstances/TableReservedInstances";

export default {
  name: "ReservedInstances",
  components: {
    ReservedInstancesSearch,
    TableReservedInstances
  },
  data() {
    return {
      modal_loading: false,
      companyId: "",
      reservedInstanceId: ""
    };
  },
  methods: {
    update: function() {
      this.companyId = this.$refs.search.companyId;

      this.$api.resourceManagement
        .updateResource({
          companyId: this.companyId,
          resourceManagement: 308
        })
        .then(res => {
          setTimeout(() => {
            this.$Message.success(this.$t('common.updateSuccess'));
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: this.$t('common.exporting')
      });

      // 获取子组件数据
      this.companyId = this.$refs.search.companyId;
      this.reservedInstanceId = this.$refs.search.reservedInstanceId;
      // 下载Excel 文件
      this.$api.resourceManagement
        .exportAliEcsReservedInstance({
          companyId: this.companyId,
          accountName: this.accountName,
          reservedInstanceId: this.reservedInstanceId
        })
        .then(res => {
          let fileName = "ReservedInstances（ECS）.xls";
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success(this.$t('common.exportSuccess'));
        });
    }
  }
};
</script>

<style scoped>
.reservedInstances-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  overflow: hidden;
  font-weight: 600;
}
.reservedInstances-title > div:nth-child(1) {
  float: left;
}
.reservedInstances-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.reservedInstances-top {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/ali/reservedInstances/ReservedInstances.vue